import { useState, useEffect } from 'react';

interface IPLocation {
  latitude: number;
  longitude: number;
  city?: string;
  country?: string;
}

/**
 * Hook pour récupérer la localisation basée sur l'IP
 * Utilise l'API ip-api.com (gratuite, pas de clé requise)
 */
export const useIPLocation = () => {
  const [location, setLocation] = useState<IPLocation | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    const fetchIPLocation = async () => {
      try {
        setLoading(true);
        const response = await fetch('http://ip-api.com/json/');

        if (!response.ok) {
          throw new Error('Failed to fetch IP location');
        }

        const data = await response.json();

        if (data.status === 'success') {
          setLocation({
            latitude: data.lat,
            longitude: data.lon,
            city: data.city,
            country: data.country,
          });
        } else {
          throw new Error(data.message || 'Failed to get location');
        }
      } catch (err) {
        console.error('Error fetching IP location:', err);
        setError(err as Error);
        // Fallback to default location (Marseille, France)
        setLocation({
          latitude: 43.2962717,
          longitude: 5.3832961,
          city: 'Marseille',
          country: 'France',
        });
      } finally {
        setLoading(false);
      }
    };

    fetchIPLocation();
  }, []);

  return { location, loading, error };
};
